export default "__VITE_ASSET__DdAy4oFQ__"